// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_authentication_authentication_module_ts":"3b18b900ff1a25a3","src_app_modules_site_site_module_ts":"2e00139edf510ed6"}[chunkId] + ".js";
};